import { shallowRef } from 'vue'
import type { AiSkillDefinition } from '@/types'
import { parseSkillFile } from '@/lib/ai/skill'

const skillFiles = import.meta.glob('@/skills/*.md', {
  eager: true,
  query: '?raw',
  import: 'default'
}) as Record<string, string>

function buildSystemSkillDefinitions(): AiSkillDefinition[] {
  return Object.entries(skillFiles).flatMap(([path, raw]) => {
    try {
      return [parseSkillFile(raw)]
    } catch (err) {
      console.error(`[parseSkill] Invalid skill file ${path}:`, err)
      return []
    }
  })
}

export const systemSkillDefinitions = shallowRef<AiSkillDefinition[]>(
  buildSystemSkillDefinitions()
)

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    systemSkillDefinitions.value = buildSystemSkillDefinitions()
  })
}
